var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6675 26.6675C47.7249 26.6675 45.3325 29.0575 45.3325 32C45.3325 34.9425 47.725 37.3325 50.6675 37.3325C53.6075 37.3325 55.9999 34.9425 55.9999 32C55.9999 29.0575 53.6074 26.6675 50.6675 26.6675ZM31.9999 24C27.59 24 23.9999 27.59 23.9999 32C23.9999 36.41 27.59 40 31.9999 40C36.4099 40 39.9999 36.41 39.9999 32C39.9999 27.59 36.4099 24 31.9999 24ZM18.6675 32C18.6675 34.9425 16.2749 37.3325 13.3325 37.3325C10.3924 37.3325 8 34.9425 8 32C8 29.0575 10.3925 26.6675 13.3325 26.6675C16.275 26.6675 18.6675 29.0575 18.6675 32Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.d09be516.svg";
export { ForwardRef as ReactComponent };